import { render, staticRenderFns } from "./deduction-detail.vue?vue&type=template&id=7ad0a382&"
import script from "./deduction-detail.vue?vue&type=script&lang=js&"
export * from "./deduction-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports